/* global jsonObject */

function pushObject(index, title, description) {
    if (typeof jsonObject !== 'undefined') {
        if (jsonObject.items.length > 0) {
            jsonObject.items.push({ Id: index, Title: title, Description: description });
        }
    }
}
function clearObject() {
    if (typeof jsonObject !== 'undefined') {
        if (jsonObject.items.length > 0) {
            jsonObject.items.splice(0, jsonObject.items.length);
        }
    }
}
function strip(html) {
    var tmp = document.createElement('DIV');
    tmp.innerHTML = html;

    return tmp.textContent || tmp.innerText || '';
}
window.GetGlossryItems = function() {
    if (typeof jsonObject === 'undefined') {
        clearObject();
    } else if (jsonObject.items.length > 0) {
        ReadJSonList();
        $('.js-toggle-tooltip').tooltip();
    }
};

function FillJSonList(index, object) {
    var title = $(object).find('span > h2').text();
    var description = $(object).find('.text-content.vspace-sm > span').text();
    pushObject(index, title, description);
}

function ReadJSonList() {
    var $glossaryDivs = $('div[data-popup*="glossary"]');
    $.each(jsonObject.items, function (itemIndex, item) {
        $.each($glossaryDivs, function (index, element) {
            var originalSource = $(element).html();
            var source = originalSource.toLowerCase();
            var title = item.Title.toLowerCase();
            var titleLength = title.length;
            if (source.indexOf(title, 0) !== -1) {
                var currentIndex = source.indexOf(title, 0);
                var currentValue = originalSource.substring(currentIndex, currentIndex + titleLength);
                originalSource = originalSource.replace(new RegExp('(' + currentValue + ')(?!([^<]+)?>)'), '<span class="dashed toggle-tooltip js-toggle-tooltip" data-mouseover="true" data-title="' + 'titlePlaceholder" data-description="' + 'descriptionPlaceholder">' + currentValue + '</span>');
                if (originalSource.indexOf('titlePlaceholder') >= 0) {
                    originalSource = originalSource.replace(new RegExp('titlePlaceholder', 'g'), strip(item.Title.replace(/\"/g, '')));
                    originalSource = originalSource.replace(new RegExp('descriptionPlaceholder', 'g'), strip(item.Description.replace(/\"/g, '')));
                    $(element).html(originalSource);

                    return false;
                }
            }

        });
    });
}